import React, {FunctionComponent, useState} from 'react';
import {ChallengeTeamData} from "/src/domain/challenges/ChallengeTeamData";
import {updatePageData} from "/src/contexts/Page";
import axios from "axios";
import { links } from "/src/domain/shared/links";

export interface ChallengeTeamContextProps {
    changeTeamName: (id: number, name: string) => void;
    addToTeam: (id: number, email: string) => void;
    // deleteParticipant: (id: number, participantId: string) => void;
}


export const ChallengeTeamContext = React.createContext<ChallengeTeamContextProps | undefined>(undefined)

export interface ChallengeTeamProviderProps {
    updateData: updatePageData<ChallengeTeamData>
}

export const ChallengeTeamProvider: FunctionComponent<ChallengeTeamProviderProps> = ({children, updateData}) => {

    const changeTeamName = async (id: number, name: string) => {
        try {
            const result = await axios.put(`${links.challengesOrigin}/api/challenges/team/name`, {
                teamId: id,
                name
            });

            updateData(result.data);
        } catch (e) {

        }
    };

    const addToTeam = async (id: number, email: string) => {
        try {
            const result = await axios.post(`${links.challengesOrigin}/api/challenges/team/add`, {
                teamId: id,
                email
            });

            updateData(result.data);
        } catch (e) {

        }
    }

    return (
        <ChallengeTeamContext.Provider
            value={{
                changeTeamName,
                addToTeam
            }}>{children}
        </ChallengeTeamContext.Provider>
    )
}
